import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Dropdown, Checkbox } from "semantic-ui-react";
import Switch from "react-switch";
import {
  toggleOutboundSms,
  setSmsWorkspaces,
  setSmsParsedFields,
  setSmsSelectedValues,
  setSmsRequiredSetting,
  fetchOutboundSmsWorkspaces,
} from "../../store/outboundSmsSlice";

const OutboundSmsWebhook = ({ showOutbound: fallbackWebhook }) => {
  const dispatch = useDispatch();
  const outbound = useSelector((s) => s.outboundSms);

  const showOutboundSection =
    outbound.enabled &&
    (fallbackWebhook === 0 ||
      fallbackWebhook === "0" ||
      fallbackWebhook === false ||
      !fallbackWebhook);

  useEffect(() => {
    dispatch(fetchOutboundSmsWorkspaces());
  }, [dispatch]);

  const getParsedFields = (workspaceId) => {
    const workspace = outbound.workspaces?.find((w) => w?.workspace_id === workspaceId);
    const fields = workspace?.parsed_fields;
    return Array.isArray(fields) ? fields.filter((f) => f?.key?.trim()) : [];
  };

  const workspaceOptions =
    outbound.workspaces?.filter((w) => w?.workspace_id && w?.workspace_name).map((w) => ({
      key: w.workspace_id,
      text: w.workspace_name,
      value: w.workspace_id,
    })) || [];

  return (
    <div className="webhook-section-card">
      <div className="webhook-section-header">
        <div className="webhook-section-title">
          <label className="webhook-main-label">Outbound SMS</label>
          <Switch
            onChange={(value) => dispatch(toggleOutboundSms(value))}
            checked={outbound.enabled}
            onColor="#86d3ff"
            onHandleColor="#2693e6"
            handleDiameter={30}
            uncheckedIcon={false}
            checkedIcon={false}
            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
            height={20}
            width={48}
            className="react-switch"
            id="material-switch-outbound-sms"
          />
        </div>
      </div>

      {showOutboundSection && (
        <div className="webhook-card-content">
          <div className="webhook-filter-rule">
            <label className="webhook-filter-label">Add Outbound SMS Workspaces</label>
            <Dropdown
              placeholder="Searchable Select Workspaces"
              fluid
              multiple
              search
              selection
              icon="search"
              className="webhook-searchable-dropdown"
              options={workspaceOptions}
              value={outbound.selectedWorkspaces || []}
              onChange={(e, d) => dispatch(setSmsWorkspaces(d.value))}
            />

            {(outbound.selectedWorkspaces || []).map((wsId) => {
              if (!wsId) return null;

              const fields = getParsedFields(wsId);
              const selectedFieldKeys = outbound.parsedFields?.[wsId] || [];
              const rowSelectedValues = outbound.selectedValues?.[wsId] || {};
              const workspaceName =
                outbound.workspaces?.find((w) => w?.workspace_id === wsId)?.workspace_name ||
                `Workspace ${wsId}`;

              const fieldOptions = fields.map((f, idx) => ({
                key: `${wsId}-field-${idx}`,
                text: f.key,
                value: f.key,
              }));

              return (
                <div key={`workspace-${wsId}`} className="webhook-workspace-config">
                  <label className="webhook-filter-label">
                    Add webhook filtering rules for <b>{workspaceName}</b>
                  </label>

                  <Dropdown
                    placeholder="Select filtering fields"
                    fluid
                    multiple
                    selection
                    options={fieldOptions}
                    value={selectedFieldKeys}
                    onChange={(e, d) => {
                      const v = (d.value || []).filter(
                        (val) => typeof val === "string" && !val.startsWith("header")
                      );
                      dispatch(setSmsParsedFields({ workspaceId: wsId, fields: v }));
                    }}
                  />

                  {selectedFieldKeys.map((field) => {
                    if (!field?.trim()) return null;

                    const f = fields.find((x) => x?.key === field);
                    const validValues = (f?.values || []).filter(
                      (v) => v !== null && v !== undefined && String(v).trim() !== ""
                    );
                    if (!validValues.length) return null;

                    return (
                      <div key={`${wsId}-${field}`} className="webhook-filter-rule">
                        <label className="webhook-filter-label">
                          Webhook will trigger if <b>{field}</b> option equals
                        </label>
                        <Dropdown
                          fluid
                          multiple
                          selection
                          placeholder={`Choose ${field} value`}
                          options={validValues.map((v, idx) => ({
                            key: `${wsId}-${field}-${idx}`,
                            text: String(v),
                            value: String(v),
                          }))}
                          value={rowSelectedValues[field] || []}
                          onChange={(e, d) =>
                            dispatch(
                              setSmsSelectedValues({
                                workspaceId: wsId,
                                field,
                                values: d.value,
                              })
                            )
                          }
                        />
                      </div>
                    );
                  })}

                  <div className="webhook-checkbox-container">
                    <Checkbox
                      checked={outbound.requiredSettings[wsId] || false}
                      onChange={(e, data) =>
                        dispatch(
                          setSmsRequiredSetting({ workspaceId: wsId, value: data.checked })
                        )
                      }
                    />
                    <label
                      className="webhook-checkbox-label"
                      onClick={() =>
                        dispatch(
                          setSmsRequiredSetting({
                            workspaceId: wsId,
                            value: !outbound.requiredSettings[wsId],
                          })
                        )
                      }
                    >
                      Use the "if all required fields are gathered" rule for {workspaceName} to determine when to pass a payload
                    </label>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default OutboundSmsWebhook;
